// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CaseManualResource extends Resource {
    basePath: string = 'cases/case-manual/';

    objectPath: string = 'cases/case-manual/{ident}/';
}
